module.exports = __webpack_public_path__ + "resources/5c18807a0cca510c184e05f03b2d8ad8.png";